import { SiteLink } from 'components/shared';
import { getLinkHref } from 'lib/utils/helpers';
import { useEffect, useRef } from 'react';

const Navigation = ({ links, activeSlug }) => {
  const activeLinkRef = useRef(null);

  useEffect(() => {
    if (activeLinkRef?.current) {
      activeLinkRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
        inline: 'center',
      });
    }
  }, [activeLinkRef]);

  return (
    <nav className="border-b border-[rgba(0,0,0,0.05)] py-7">
      <ol className="hide-scrollbar flex items-center gap-[4px] overflow-x-auto md:flex-wrap md:justify-center">
        {links.map(({ link, text }, index, { length }) => {
          const isFirst = index === 0;
          const isLast = index === length - 1;
          return (
            <li
              ref={link.slug === activeSlug ? activeLinkRef : null}
              key={text}
              className={`flex-shrink-0 font-nimbus-sans-extd-d text-[14px] font-bold focus:outline-none lg:text-[16px] ${
                isFirst && 'pl-4'
              } ${isLast && 'pr-4'}`}
            >
              <SiteLink
                className={`${link.slug === activeSlug ? 'underline' : ''} focus:outline-none`}
                href={getLinkHref(link)}
              >
                {text}
              </SiteLink>
              {!isLast && ','}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Navigation;
